import * as FullStory from '@fullstory/browser';
import sharedConfig from 'shared-assets/src/config-environments/config';
import somePathAsserted from 'shared-assets/lib/utils/paths/path-assertion';

const isSelfSignupEntryPath = currentPath =>
  /^\/v2\/#\/self-signup/.test(currentPath);

/**
 * Checks if at least one of the pathsToAssert matches with the current path
 * @function initFullstory
 * @return {void}
 */
const initFullstory = () => {
  const currentPath = window.location.pathname + window.location.hash;
  if (
    sharedConfig?.fullstoryConfig?.enabled &&
    !somePathAsserted(currentPath, sharedConfig?.fullstoryConfig?.untrackedPaths)
  ) {
    FullStory.init({ orgId: sharedConfig?.fullstoryConfig?.orgId });
    if (isSelfSignupEntryPath(currentPath)) {
      FullStory.anonymize();
    }
  }
};

initFullstory();
